// extracted by mini-css-extract-plugin
export default {"loading":"hfmy4DpPM4jF056PWhkV","placeHolderShimmer":"DkCUvGUTUq1OrwGcF4xx"};